module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fCzpV"))).then(() => module.bundle.root('gtEzC'));